<template>
    <div class="meeting">
        <advertising-figure :bannerSrc="bannerSrc"/>
        <div class="inner-page-nav">
            <inner-page-nav />
        </div>
        <div class="inner-page-content">
            <public-title :title="title">
                <span class="sub">Notice of the meeting</span>
            </public-title>
            <div class="list-wrap">
                <!-- <div class="list">
                    <div class="high">
                        <h2 class="tit">防疫须知</h2>
                        <span @click="jumpTo('noticeDetailPage')">查看详情</span>
                    </div>
                    <span class="time">发布日期: {{ simpleDateFormat(currentConference.notices!==undefined && currentConference.notices.length>0?currentConference.notices[0].create_time:"暂无") }}</span>
                </div> -->
                <div class="list">
                    <div class="high">
                        <h2 class="tit">温馨提示</h2>
                        <span  @click="jumpTo('hintDetailPage')">查看详情</span>
                    </div>
                    <span class="time">发布日期: {{ simpleDateFormat(currentConference.notices!==undefined && currentConference.notices.length>0?currentConference.notices[0].create_time:"暂无") }}</span>
                </div>
   
            </div>
        </div>
    </div>
</template>

<script>
import AdvertisingFigure from "@components/advertising";
import InnerPageNav from "@components/tool-nav";
import PublicTitle from "@components/title";
import CurrentConferMixin from "@/mixin/CurrentConference"

export default {
    name: "MeetingDetails",
    components: {
        PublicTitle,
        AdvertisingFigure,
        InnerPageNav,
    },
    mixins: [CurrentConferMixin],
    data() {
        return {
            bannerSrc:require("@assets/img/meeting-banner.png"),
            title: "参会须知",
        };
    },

    methods: {
        jumpTo(path) {
            this.$router.push({
                name: path,
            });
        },
        getInfo() {
            console.log(this.$route.params);
        },
    },
    watch: {
        $route: "getInfo",
    },
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/innerpagenav.scss";

.inner-page-nav {
    position: relative;
    width: 1200px;
    height: 60px;
    padding: 0 15px;
    margin: 0 auto;
}

.inner-page-content {
    margin: 60px 0;
}

.list {
    @include flex-between;
    width: 1200px;
    height: 50px;
    padding: 0 15px;
    margin: 30px auto;
    border-bottom: 1px solid #eee;

    .high {
        height: 100%;

        span {
            font-size: 12px;
            text-align: center;
            color: $defaultColor;
            cursor: pointer;
        }
    }

    .tit {
        position: relative;
        font-size: 18px;
        color: #666;
        font-weight: normal;
        margin-bottom: 5px;
    }

    .time {
        font-size: 14px;
        color: #999;
    }
}
</style>